import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import InformesBackButton from '../../components/shared/InformesBackButton';
import InformesDefinicionesPanel from '../../components/shared/InformesDefinicionesPanel';
import { resolveInformesModuloFromPath } from '../../config/informesModulos';
import type { ModuloInformePersonalizado } from '../../utils/informePersonalizadoDefinicion';

const InformePersonalizadoPage: React.FC = () => {
  const location = useLocation();
  const informesModulo = useMemo(
    () => resolveInformesModuloFromPath(location.pathname),
    [location.pathname],
  );
  const modulo: ModuloInformePersonalizado = informesModulo.pathPrefix === 'compras'
    ? 'Compras'
    : informesModulo.pathPrefix === 'contabilidad'
      ? 'Contabilidad'
      : informesModulo.pathPrefix === 'tesoreria'
        ? 'Tesoreria'
        : 'Ventas';
  const nombreModulo = modulo === 'Contabilidad'
    ? 'contabilidad'
    : modulo === 'Compras'
      ? 'compras'
      : modulo === 'Tesoreria'
        ? 'tesorería'
        : 'ventas';
  const [editando, setEditando] = useState(false);

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh', maxWidth: '100%', overflowX: 'hidden' }}>
      <Card sx={{ bgcolor: '#ffffff', borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          {!editando && (
            <Box sx={{ mb: 2 }}>
              <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
                <InformesBackButton to={informesModulo.hubPath} />
                <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#1976d2' }}>
                  Informe personalizado
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Consultas guardadas de {nombreModulo}.
              </Typography>
            </Box>
          )}
          <InformesDefinicionesPanel modulo={modulo} onEditingChange={setEditando} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default InformePersonalizadoPage;
